module.exports = __webpack_public_path__ + "img/_PWK2484_-PSedit_.d9c145df.jpeg";